// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { CustomAppState } from "@vanmeter/App/Store/Reducers";
import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";

export function hasChanges(state: CustomAppState) {
    const {
        userSetup: { userId, editingUser },
    } = state.pages;
    const user = getAccountState(state, userId).value;
    const assignedVmiEditingUserRoles = state.xVmiUser.assignedRoles;
    const assignedVmiUserRoles = user?.role.split(",");
    if (!user || !editingUser) {
        return false;
    }
    return (
        user.email !== editingUser.email ||
        user.firstName !== editingUser.firstName ||
        user.lastName !== editingUser.lastName ||
        !isEqual(sortBy(assignedVmiUserRoles), sortBy(assignedVmiEditingUserRoles)) ||
        user.approver !== editingUser.approver ||
        user.isApproved !== editingUser.isApproved
    );
}

export const getCurrentEditingUser = (state: ApplicationState) => state.pages.userSetup.editingUser;
